import { Injectable } from '@angular/core';
import * as Sentry from '@sentry/capacitor';
import { SentryWrapper } from 'src/app/wrappers/sentry.wrapper';
import {
  mapMSSeverityToSentrySeverity,
  MSRemoteLoggerCategory,
  MSRemoteLoggerData,
  MSRemoteLoggerSeverity
} from './utils/remote-logger.utils';

@Injectable({
  providedIn: 'root'
})
export class RemoteLoggerAdapter {
  constructor(private sentryWrapper: SentryWrapper) {}

  setUserProperty(property: Record<string, any>): void {
    this.sentryWrapper.setUser(property);
  }

  setGlobalAttributes(attributes: Record<string, any>): void {
    this.sentryWrapper.setGlobalAttributes(attributes);
  }

  setTag(key: string, value: string) {
    this.sentryWrapper.setTag(key, value);
  }

  addBreadcrumbs(message: string, category: MSRemoteLoggerCategory, level: MSRemoteLoggerSeverity, data?: MSRemoteLoggerData) {
    const sentryLevel = mapMSSeverityToSentrySeverity(level);
    const breadcrumb: Sentry.Breadcrumb = {
      message,
      category,
      data,
      level: sentryLevel
    };

    this.sentryWrapper.addBreadcrumb(breadcrumb);
  }

  captureException(exception: Error) {
    this.sentryWrapper.captureException(exception);
  }

  log(message: string, category: MSRemoteLoggerCategory, level: MSRemoteLoggerSeverity, data?: any): void {
    const attributes = data === undefined
      ? { category: category }
      : {
        category: category,
        ...data
      };
    switch (level) {
      case MSRemoteLoggerSeverity.DEBUG:
        this.sentryWrapper.debug(message, attributes);
        break;
      case MSRemoteLoggerSeverity.INFO:
        this.sentryWrapper.info(message, attributes);
        break;
      case MSRemoteLoggerSeverity.WARN:
        this.sentryWrapper.warn(message, attributes);
        break;
      case MSRemoteLoggerSeverity.ERROR:
        this.sentryWrapper.error(message, attributes);
        break;
      case MSRemoteLoggerSeverity.FATAL:
        this.sentryWrapper.fatal(message, attributes);
        break;
      default:
        this.sentryWrapper.debug(message, attributes);
        break;
    }
  }
}
